import { Grade11CourseOverviewData } from "../../data/OSSDOverviewData/Grade11CourseOverviewData";
import Grade from "../../components/CourseComp/Grade";

export default function GradeElevenOverviewPage() {
    return (
        <div>
            <Grade data={Grade11CourseOverviewData} />
        </div>
    )
}